import { IToastProps } from 'do-front-end-utils';
import { HIDE_TOAST, SHOW_TOAST } from '../constants/ActionTypes';

/**
 * Action to show toast
 * @param {IToastProps} payload - Toast payload
 * @returns {IToastAction} Action object
 */
export interface IToastAction {
  type: typeof SHOW_TOAST | typeof HIDE_TOAST;
  payload: IToastProps;
}

/**
 * Action to show toast
 * @param {IToastProps} payload - Toast payload
 * @returns {IToastAction} Action object
 */
export const showToast = (payload: IToastProps): IToastAction => ({
  type: SHOW_TOAST,
  payload,
});

/**
 * Action to hide toast
 * @returns {IToastAction} Action object
 */
export const hideToast = () => ({
  type: HIDE_TOAST,
});
